import { render, staticRenderFns } from "./NewsShow.vue?vue&type=template&id=36aa1851&scoped=true"
import script from "./NewsShow.vue?vue&type=script&lang=js"
export * from "./NewsShow.vue?vue&type=script&lang=js"
import style0 from "./NewsShow.vue?vue&type=style&index=0&id=36aa1851&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36aa1851",
  null
  
)

export default component.exports